import { Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { CustomTranslationsService } from '../translations';

@Pipe({
  name: 'translateOperatingStateModifier',
})
export class TranslateOperatingStateModifierPipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: string): string {
    if (value && this.customTranslationsService.OPERATING_STATE_MODIFIER[value]) {
      return this.translateService.instant(
        this.customTranslationsService.OPERATING_STATE_MODIFIER[value] ?? value
      );
    }

    return value;
  }
}
